import {Injectable} from '@angular/core';
import {AppConfigService} from './app-config.service';
import { HttpClient } from '@angular/common/http';
import {catchError, tap} from 'rxjs';

export interface FieldValidation {
    minLength?: number;
    maxLength?: number;
    pattern?: string;
    required?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class ValidationService {
    title = 'Validation Service';

    constructor(
        private appConfigService: AppConfigService,
        private http: HttpClient
    ) {}

    validateDocumentIdentifier(documentIdentifier: string) {
        const logPrefix = `${this.title} - validateDocumentIdentifier`;

        console.debug(logPrefix, documentIdentifier);

        return this.http.post(`${this.appConfigService.settings.apiGatewayUrl}/validation/documentIdentifier`, documentIdentifier).pipe(
            tap(response => {
                console.debug(`${logPrefix} - response:`, response);
            }),
            catchError(error => {
                console.error(`${logPrefix} - error:`, error);
                return error;
            })
        );
    }

    validateSurveyIdentifier(surveyIdentifier: string) {
        const logPrefix = `${this.title} - validateSurveyIdentifier`;

        console.debug(logPrefix, surveyIdentifier);

        return this.http.post(`${this.appConfigService.settings.apiGatewayUrl}/validation/surveyIdentifier`, surveyIdentifier).pipe(
            tap(response => {
                console.debug(`${logPrefix} - response:`, response);
            }),
            catchError(error => {
                console.error(`${logPrefix} - error:`, error);
                return error;
            })
        );
    }

    isStringFieldValid(validation: FieldValidation, data: string): boolean {
        if (validation.required && data.length === 0) {
            return false;
        }

        if (validation.minLength && data.length < validation.minLength) {
            return false;
        }

        if (validation.maxLength && data.length > validation.maxLength) {
            return false;
        }

        if (validation.pattern) {
            const regex = new RegExp(validation.pattern);
            if (!regex.test(data)) {
                return false;
            }
        }

        return true;
    }
}
